import "./App.css";
import Countries from "./components/views/countries/Countries";

function App() {
  return (
    <div className="app">
      <Countries />
    </div>
  );
}

export default App;
